import Layout from '@/components/layout/Layout'
import { asyncComponent } from './utils'

let pubRoutes = [
  {
    path: '/sample',
    name: 'Sample',
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'SampleList',
        components: {
          default: asyncComponent('sample/List')
        }
      },
      {
        path: 'write',
        name: 'SampleWrite',
        components: {
          default: asyncComponent('sample/Write')
        }
      },
      {
        path: 'view',
        name: 'SampleView',
        components: {
          default: asyncComponent('sample/View')
        }
      },
      {
        path: 'hashtag/write',
        name: 'PubHashtagWrite',
        components: {
          default: asyncComponent('sample/hashtag/Write')
        }
      },
      {
        path: 'review/list',
        name: 'PubReview',
        components: {
          default: asyncComponent('sample/review/List')
        }
      }
    ]
  },
  {
    path: '/sample/ver2/template',
    name: 'Ver2Tamplate',
    component: Layout,
    children: [
      {
        path: 'listA',
        name: 'ListA',
        components: {
          default: asyncComponent('sample/ver2/template/ListA')
        }
      },
      {
        path: 'list',
        name: 'List',
        components: {
          default: asyncComponent('sample/ver2/template/List')
        }
      }
    ]
  },
  {
    path: '/sample/ver2/common',
    name: 'Ver2Common',
    component: Layout,
    children: [
      {
        path: 'list',
        name: 'List',
        components: {
          default: asyncComponent('sample/ver2/common/List')
        }
      }
    ]
  }
]

export default pubRoutes
